var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 25.75C9.375 26.3023 8.92728 26.75 8.375 26.75H3.5C2.94772 26.75 2.5 26.3023 2.5 25.75V12.75C2.5 12.1977 2.94772 11.75 3.5 11.75H8.375C8.92728 11.75 9.375 12.1977 9.375 12.75V25.75ZM18.4375 5.25C18.4375 4.69772 17.9898 4.25 17.4375 4.25H12.5625C12.0102 4.25 11.5625 4.69772 11.5625 5.25V25.75C11.5625 26.3023 12.0102 26.75 12.5625 26.75H17.4375C17.9898 26.75 18.4375 26.3023 18.4375 25.75V5.25ZM27.5 15.25C27.5 14.6977 27.0523 14.25 26.5 14.25H21.625C21.0727 14.25 20.625 14.6977 20.625 15.25V25.75C20.625 26.3023 21.0727 26.75 21.625 26.75H26.5C27.0523 26.75 27.5 26.3023 27.5 25.75V15.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/Leads.82ce3a26ac811710ce9a950f4115faa9.svg";
export { ForwardRef as ReactComponent };